import type { Contact } from '@features/contacts/types/contact'
import { ContactType } from '@features/contacts/types/contactType'
import { joinPersonName } from '@features/contacts/utils/joinPersonName'

import type { SupplierFormValues } from '../types/supplierForm'
import { getAdditionalContactPersonsPayload, getPrimaryContactPersonPayload } from './getSupplierContactPersonsPayload'

interface GetCreateSupplierContactPayloadParams {
  organizationId: string
  values: SupplierFormValues
}

const getFilledValue = (value: string): string | undefined => value.trim() || undefined

// Creates the POST body for a new supplier from the tab currently on screen.
export const getCreateSupplierContactPayload = ({
  organizationId,
  values,
}: GetCreateSupplierContactPayloadParams): Partial<Contact> => {
  const isPerson = values.type === ContactType.Person
  const name = isPerson ? joinPersonName(values.firstName, values.lastName) : values.name.trim()
  const additionalContactPersons = getAdditionalContactPersonsPayload(values.additionalContactPersons)
  const contactPersons = [...(isPerson ? [getPrimaryContactPersonPayload(values)] : []), ...additionalContactPersons]

  return {
    cityText: getFilledValue(values.cityText),
    contactPersons: contactPersons.length > 0 ? contactPersons : undefined,
    countryId: getFilledValue(values.countryId),
    defaultExpenseAccountId: values.countryId === 'DK' ? getFilledValue(values.defaultExpenseAccountId) : undefined,
    defaultExpenseProductDescription: getFilledValue(values.defaultExpenseProductDescription),
    defaultTaxRateId: getFilledValue(values.defaultTaxRateId),
    email: isPerson ? getFilledValue(values.email) : undefined,
    isCustomer: false,
    isSupplier: true,
    name,
    organizationId,
    phone: getFilledValue(values.phone),
    registrationNo: getFilledValue(values.registrationNo),
    stateText: getFilledValue(values.stateText),
    street: getFilledValue(values.street),
    type: values.type,
    vatNo: getFilledValue(values.vatNo),
    zipcodeText: getFilledValue(values.zipcodeText),
  }
}
